<script setup>
import { defineProps, defineEmits, computed} from "vue";
import NotaFiscalService from "@/api/v2/services/NotaFiscalService";
import UtilMoney from "../../../../utils/UtilMoney";
import UtilObject from "@/utils/UtilObject";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
    "pagamentoNovo",
    "notasFiscaisRecebidas",
    "adiantamentos"
]);

const emits = defineEmits([
    "update:alteraContaAPagar",
    "update:alteraPagamentoNovo",
]);

//==================================================================//
//======================= Altera Conta a Pagar =====================//
//==================================================================//

const alteraContaAPagar = (update)=>{

    emits('update:alteraContaAPagar',update);

};

//==================================================================//
//================== Altera Pagamento Novo =========================//
//==================================================================//

const alteraPagamentoNovo = (updatePagamentoNovo)=>{

    // Calculo de Valor para Reservar Restante
    let valorParaReservarRestante = calculaValorParaReservarRestante(updatePagamentoNovo?.valorReservado);

    let updateContaAPagar = {
        valorParaReservarRestante: valorParaReservarRestante,
    }

    emits('update:alteraPagamentoNovo',updateContaAPagar, updatePagamentoNovo);

};

//==================================================================//
//=============== Desativa Selecionar Contas a Pagar ===============//
//==================================================================//

const desativaSelecionarContaAPagar = computed(() => {

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    return false;

});

//==================================================================//
//=================== Mostra Seletor de Vinculo ====================//
//==================================================================//

const mostraSeletorVinculo = computed(()=>{

    return props?.pagamentoNovo?.vinculoTipo != "Nenhum";

});

//==================================================================//
//============= Mostra Seletor de Nota Fiscal Recebida =============//
//==================================================================//

const mostraSeletorNotaFiscalRecebida = computed(() => {

    return props?.pagamentoNovo?.vinculoTipo == "Nota Fiscal Recebida";

});

//==================================================================//
//================== Mostra Seletor de Adiantamento ================//
//==================================================================//

const mostraSeletorAdiantamento = computed(() => {

    return props?.pagamentoNovo?.vinculoTipo == "Adiantamento";

});

//==================================================================//
//=============== Mostra Baixar Nota Fiscal Recebida ===============//
//==================================================================//

const mostraBaixarNotaFiscalRecebida = computed(() => {

    return props?.pagamentoNovo?.notaFiscalRecebida?.id;

});

//==================================================================//
//=== Mostra Seletor de Nota Fiscal Recebida Valor Para Reservar ===//
//==================================================================//

const mostraNotaFiscalRecebidaValorParaReservar = computed(() => {

    return props?.pagamentoNovo?.notaFiscalRecebida?.id;

});

//==================================================================//
//============= Mostra Adiantamento Valor Para Vincular ============//
//==================================================================//

const mostraAdiantamentoValorParaVincular = computed(() => {

    return props?.pagamentoNovo?.adiantamento?.id;

});

//==================================================================//
//====================== Mosta Valor Desconto ======================//
//==================================================================//

const mostraValorDesconto = computed(()=>{

    // O Valor de Desconto só pode ser Preenchido quando o Vinculo for de Nota Fiscal Recebida.
    return props?.pagamentoNovo?.vinculoTipo == "Nota Fiscal Recebida";

});

//==================================================================//
//========= Cor Toogle Vinculo Tipo Nota Fiscal Recebida ===========//
//==================================================================//

const corToogleVinculoTipoNotaFiscalRecebida = computed(()=>{

    return props?.pagamentoNovo?.vinculoTipo == "Nota Fiscal Recebida" ? "primary" : "#9E9E9E";

});

//==================================================================//
//============= Cor Toogle Vinculo Tipo Adiantamento ===============//
//==================================================================//

const corToogleVinculoTipoAdiantamento = computed(()=>{

    return props?.pagamentoNovo?.vinculoTipo == "Adiantamento" ? "primary" : "#9E9E9E";

});

//==================================================================//
//========== Cor Nota Fiscal Recebida Valor para Reservar ==========//
//==================================================================//

const corNotaFiscalRecebidaValorParaReservar = computed(()=>{

    return props?.pagamentoNovo?.notaFiscalRecebida?.valorParaReservarRestante >= 0 ? "green" : "red";

});

//==================================================================//
//============= Cor Adiantamento Valor para Vincular ===============//
//==================================================================//

const corAdiantamentoValorParaVincular = computed(()=>{

    return props?.pagamentoNovo?.adiantamento?.valorParaVincularRestante >= 0 ? "green" : "red";

});

//==================================================================//
//======== Cor Conta a Pagar Valor para Reservar Restante ==========//
//==================================================================//

const corContaAPagarValorParaReservarRestante = computed(()=>{

    return props?.contaAPagar?.valorParaReservarRestante >= 0 ? "green" : "red";

});

//==================================================================//
//======================= Vinculo Status ===========================//
//==================================================================//

const vinculoStatus = computed(() => {

    let vinculoTipo = props?.pagamentoNovo?.vinculoTipo || "Nenhum";
    let notaFiscalRecebidaID = props?.pagamentoNovo?.notaFiscalRecebida?.id || "";
    let adiantamentoID = props?.pagamentoNovo?.adiantamento?.id || "";

    // Se o Vinculo não é Requirido
    if(vinculoTipo == "Nenhum"){
        return "Vinculo Não Requirido";
    }

    // Se o Vinculo Requirido é Nota Fiscal Recebida e uma Nota Fiscal Recebida foi Selecionada.
    if(vinculoTipo == "Nota Fiscal Recebida" && notaFiscalRecebidaID != ""){
        return "Vinculo de Nota Fiscal Recebida Realizado";
    }

    // Se o Vinculo Requirido é Nota Fiscal Recebida e uma Nota Fiscal Recebida não foi Selecionada.
    if(vinculoTipo == "Nota Fiscal Recebida" && notaFiscalRecebidaID == ""){
        return "Vinculo de Nota Fiscal Recebida não Realizado";
    }

    // Se o Vinculo Requirido é Adiantamento e um Adiantamento foi Selecionada.
    if(vinculoTipo == "Adiantamento" && adiantamentoID != ""){
        return "Vinculo de Adiantamento Realizado";
    }

    // Se o Vinculo Requirido é Adiantamento e um Adiantamento não foi Selecionada.
    if(vinculoTipo == "Adiantamento" && adiantamentoID == ""){
        return "Vinculo de Adiantamento não Realizado";
    }

    return "Validação de Vinculo Falhou";

});

//==================================================================//
//====================== Desativa Toggle Vinculo ===================//
//==================================================================//

const desativaToogleVinculo = computed(() => {

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    // Se o Vinculo não for Requirido.
    if(vinculoStatus.value == "Vinculo Não Requirido"){
        return true;
    }

    return false;

});

//==================================================================//
//===================== Desativa Valor Desconto ====================//
//==================================================================//

const desativaBaixarNotaFiscalRecebida = computed(() => {

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    // Se o Vinculo não for Vinculo de Nota Fiscal Recebida Realizado
    if(vinculoStatus.value != "Vinculo de Nota Fiscal Recebida Realizado"){
        return true;
    }

    return false;

});

//==================================================================//
//============ Desativa Seletor de Nota Fiscal Recebida ============//
//==================================================================//

const desativaSeletorDeNotaFiscalRecebida = computed(() => {

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    // Se o Vinculo não for Vinculo de Nota Fiscal Recebida Realizado
    // Se o Vinculo não for Vinculo de Nota Fiscal Recebida não Realizado
    if(
        vinculoStatus.value != "Vinculo de Nota Fiscal Recebida Realizado" &&
        vinculoStatus.value != "Vinculo de Nota Fiscal Recebida não Realizado"
    ){
        return true;
    }

    return false;

});

//==================================================================//
//========== Desativa Seletor de Valor de Adiantamento =============//
//==================================================================//

const desativaSeletorDeAdiantamento = computed(() => {

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    // Se o Vinculo não for Vinculo de Adiantamento Realizado
    // Se o Vinculo não for Vinculo de Adiantamento não Realizado
    if(
        vinculoStatus.value != "Vinculo de Adiantamento Realizado" &&
        vinculoStatus.value != "Vinculo de Adiantamento não Realizado"
    ){
        return true;
    }

    return false;

});

//==================================================================//
//===================== Desativa Valor Desconto ====================//
//==================================================================//

const desativaValorDesconto = computed(() => {

    let vinculoTipo = props?.pagamentoNovo?.vinculoTipo || "Nenhum";

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    // Se o Vinculo não for de Recebimento de Nota Fiscal.
    if(vinculoTipo != "Nota Fiscal Recebida"){
        return true;
    }

    // Se o Vinculo de Nota Fiscal Recebida não tiver sido realizado.
    // Se o Vinculo falhou.
    if(
        vinculoStatus.value == "Vinculo de Nota Fiscal Recebida não Realizado" ||
        vinculoStatus.value == "Validação de Vinculo Falhou"
    ){
        return true;
    }

    return false;

});

//==================================================================//
//===================== Desativa Valor Pagamento ===================//
//==================================================================//

const desativaValorPagamento = computed(() => {

    // Se os Controles foram Desativados.
    if(props?.controlesDesativados == true){
        return true
    }

    // Se o Vinculo de Nota Fiscal Recebida não tiver sido realizado.
    // Se o Vinculo de Adiantamento não tiver sido realizado.
    // Se o Vinculo falhou.
    if(
        vinculoStatus.value == "Vinculo de Nota Fiscal Recebida não Realizado" ||
        vinculoStatus.value == "Vinculo de Adiantamento não Realizado" ||
        vinculoStatus.value == "Validação de Vinculo Falhou"
    ){
        return true;
    }

    return false;

});

//==================================================================//
//================ Ao Selecionar Conta a Pagar =====================//
//==================================================================//

const aoSelecionarContaAPagar = ()=>{

    alteraContaAPagar({
        selecionado: !props?.contaAPagar?.selecionado,
    })

};

//==================================================================//
//=========== Toogle Vinculo Tipo Nota Fiscal Recebida =============//
//==================================================================//

const toogleVinculoTipoNotaFiscalRecebida = async ()=>{

    if(props?.pagamentoNovo?.vinculoTipo == "Nota Fiscal Recebida"){
        return;
    }

    alteraPagamentoNovo({
        vinculoTipo: "Nota Fiscal Recebida",
        notaFiscalRecebida: {},
        adiantamento: {},
        valorDesconto: 0,
        valorPagamento: 0,
        valorReservado: 0,
    });

};

//==================================================================//
//=============== Toogle Vinculo Tipo Adiantamento =================//
//==================================================================//

const toogleVinculoTipoAdiantamento = async ()=>{

    if(props?.pagamentoNovo?.vinculoTipo == "Adiantamento"){
        return;
    }

    alteraPagamentoNovo({
        vinculoTipo: "Adiantamento",
        notaFiscalRecebida: {},
        adiantamento: {},
        valorDesconto: 0,
        valorPagamento: 0,
        valorReservado: 0,
    });

};

//==================================================================//
//============== Ao Baixar Nota Fiscal Recebida ====================//
//==================================================================//

const aoBaixarNotaFiscalRecebida = async ()=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: props?.pagamentoNovo?.notaFiscalRecebida?.chaveAcesso,
        plugNotasId: props?.pagamentoNovo?.notaFiscalRecebida?.plugNotasId
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

//==================================================================//
//============ Ao Selecionar Nota Fiscal Recebida ==================//
//==================================================================//

const aoSelecionarNotaFiscalRecebida = (notaFiscalRecebida = {}) =>{

    alteraPagamentoNovo({
        notaFiscalRecebida: notaFiscalRecebida || {},
        valorDesconto: 0,
        valorPagamento: 0,
        valorReservado: 0,
    });

}

//==================================================================//
//============ Ao Selecionar Nota Fiscal Recebida ==================//
//==================================================================//

const aoSelecionarAdiantamento = (adiantamento = {}) =>{

    alteraPagamentoNovo({
        adiantamento: adiantamento || {},
        valorDesconto: 0,
        valorPagamento: 0,
        valorReservado: 0,
    });

}

//==================================================================//
//====================== Altera Valor Desconto =====================//
//==================================================================//

const alteraValorDesconto = (valorDesconto = 0) =>{

    valorDesconto = UtilMoney.toNumber(valorDesconto);
    let valorPagamento = props?.pagamentoNovo?.valorPagamento;
    let valorReservado = valorDesconto + valorPagamento;

    alteraPagamentoNovo({
        valorDesconto: valorDesconto,
        valorReservado: valorReservado
    })

};

//==================================================================//
//========================= Altera Pagamento =======================//
//==================================================================//

const alteraValorPagamento = (valorPagamento = 0) =>{

    let valorDesconto = props?.pagamentoNovo?.valorDesconto;
    valorPagamento = UtilMoney.toNumber(valorPagamento);
    let valorReservado = valorDesconto + valorPagamento;

    alteraPagamentoNovo({
        valorPagamento: UtilMoney.toNumber(valorPagamento),
        valorReservado: valorReservado
    })

};

//==================================================================//
//================== Altera Pagamento Novo =========================//
//==================================================================//

const calculaValorParaReservarRestante = (valorReservado)=>{

    // Calculo de Valor para Reservar Restante
    let contaAPagarValorParaReservar = props?.contaAPagar?.valorParaReservar || 0;
    let pagamentoNovoValorReservado = valorReservado || 0;
    let valorParaReservarRestante = contaAPagarValorParaReservar - pagamentoNovoValorReservado;

    return valorParaReservarRestante;
};

</script>

<template>

    <div class="c-table__row">

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content c-controles">

                    <v-checkbox
                        class="c-checkbox"
                        :value="props?.contaAPagar?.selecionado"
                        :disabled="desativaSelecionarContaAPagar"
                        @change="aoSelecionarContaAPagar"
                    ></v-checkbox>

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <v-chip
                    class="c-content c-chip"
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-receipt-text
                    </v-icon>

                    <span class="c-chip__text">
                    
                        {{props?.contaAPagar?.codigo}}

                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    {{props?.contaAPagar?.forma}}

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    {{props?.contaAPagar?.tipo}}

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    {{props?.contaAPagar?.evento}}

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    {{props?.contaAPagar?.descricao}}

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content c-toogler"
                    v-show="mostraSeletorVinculo"
                >

                    <div class="c-toogles">

                        <div class="c-toogle">

                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">

                                    <v-btn
                                        class="mx-2"
                                        dark
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="desativaToogleVinculo"
                                        :color="corToogleVinculoTipoNotaFiscalRecebida"
                                        @click="toogleVinculoTipoNotaFiscalRecebida"
                                    >
                                        NF
                                    </v-btn>

                                </template>

                                <span>Vincular Nota Fiscal Recebida</span>

                            </v-tooltip>

                        </div>

                        <div class="c-toogle">

                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">

                                    <v-btn
                                        class="mx-2"
                                        dark
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="desativaToogleVinculo"
                                        :color="corToogleVinculoTipoAdiantamento"
                                        @click="toogleVinculoTipoAdiantamento"
                                    >
                                        AD
                                    </v-btn>

                                </template>

                                <span>Vincular Adiantamento</span>

                            </v-tooltip>

                        </div>

                    </div>

                    <div class="c-vinculo c-vinculo-nota-fiscal-recebida"
                        v-show="mostraSeletorNotaFiscalRecebida"
                    >

                        <div class="c-vinculo__botao"
                            v-show="mostraBaixarNotaFiscalRecebida"
                        >

                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        dark
                                        small
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="desativaBaixarNotaFiscalRecebida"
                                        @click="aoBaixarNotaFiscalRecebida"
                                    >

                                        <v-icon dark>
                                            mdi-download
                                        </v-icon>
                                    
                                    </v-btn>

                                </template>

                                <span>Baixar Nota Fiscal Recebida</span>

                            </v-tooltip>

                        </div>

                        <div class="c-vinculo__select">

                            <v-select
                                :value="props?.pagamentoNovo?.notaFiscalRecebida"
                                :items="props?.notasFiscaisRecebidas"
                                label="Nota Fiscal Recebida"
                                outlined
                                clearable
                                hide-details
                                return-object
                                item-value="numero"
                                :disabled="desativaSeletorDeNotaFiscalRecebida"
                                @change="aoSelecionarNotaFiscalRecebida"
                            >
                            
                                <template v-slot:item="{ item }">
                                    <span><strong>NF: </strong><span>{{item.numero}}</span></span>
                                </template>

                                <template v-slot:selection="{ item }">
                                    <span><strong>NF: </strong><span>{{item.numero}}</span></span>
                                </template>

                            </v-select>

                        </div>

                        <div class="c-vinculo__detalhes"
                            v-show="mostraNotaFiscalRecebidaValorParaReservar"
                        >

                            <v-chip class="c-medidor__chip"
                                :color="corNotaFiscalRecebidaValorParaReservar"
                                dark
                                label
                            >

                                Valor Disponível
                                {{UtilMoney.toR$BRL(props?.pagamentoNovo?.notaFiscalRecebida?.valorParaReservarRestante)}}

                            </v-chip>

                        </div>

                    </div>

                    <div class="c-vinculo c-vinculo-adiantamento"
                        v-show="mostraSeletorAdiantamento"
                    >

                        <div class="c-vinculo__select">

                            <v-select
                                :value="props?.pagamentoNovo?.adiantamento"
                                :items="props?.adiantamentos"
                                label="Adiantamento"
                                outlined
                                clearable
                                hide-details
                                return-object
                                item-value="codigo"
                                :disabled="desativaSeletorDeAdiantamento"
                                @change="aoSelecionarAdiantamento"
                            >
                            
                                <template v-slot:item="{ item }">
                                    <span><strong>AD: </strong><span>{{item.codigo}}</span></span>
                                </template>

                                <template v-slot:selection="{ item }">
                                    <span><strong>AD: </strong><span>{{item.codigo}}</span></span>
                                </template>

                            </v-select>

                        </div>

                        <div class="c-vinculo__detalhes"
                            v-show="mostraAdiantamentoValorParaVincular"
                        >

                            <v-chip class="c-medidor__chip"
                                :color="corAdiantamentoValorParaVincular"
                                dark
                                label
                            >

                                Valor Disponível
                                {{UtilMoney.toR$BRL(props?.pagamentoNovo?.adiantamento?.valorParaVincularRestante)}}

                            </v-chip>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    {{props?.contaAPagar?.dataVencimento}}

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    {{UtilMoney.toR$BRL(props?.contaAPagar?.valorOriginal)}}

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content">

                    <v-chip class="c-medidor__chip"
                        :color="corContaAPagarValorParaReservarRestante"
                        dark
                        label
                    >

                        {{UtilMoney.toR$BRL(props?.contaAPagar?.valorParaReservarRestante)}}

                    </v-chip>

                </div>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <vuetify-money
                    class="c-content c-money"
                    type="number"
                    outlined
                    hide-details
                    label="Valor Desconto"
                    v-show="mostraValorDesconto"
                    :value="props?.pagamentoNovo?.valorDesconto"
                    :disabled="desativaValorDesconto"
                    :properties="{ 
                        'class':'c-money__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                    @input="alteraValorDesconto"
                    
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <vuetify-money
                    class="c-content c-money"
                    type="number"
                    outlined
                    hide-details
                    label="Valor Pagamento"
                    :value="props?.pagamentoNovo?.valorPagamento"
                    :disabled="desativaValorPagamento"
                    :properties="{ 
                        'class':'c-money__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                    @input="alteraValorPagamento"
                    
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-cell">

                <div class="c-content"></div>

            </div>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*========================== Table Row =============================*/
/*==================================================================*/

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

/*==================================================================*/
/*========================= Table Cell =============================*/
/*==================================================================*/

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

/*==================================================================*/
/*====================== Content Controles =========================*/
/*==================================================================*/

.c-controles{
    display: flex;
    align-items: center;
    gap: 20px;
}

/*==================================================================*/
/*======================== Content Chip ============================*/
/*==================================================================*/

.c-chip__text{
    color: #565656;
    font-weight: 600;
}

/*==================================================================*/
/*============================= Toogler ============================*/
/*==================================================================*/

.c-toogler{
    display: flex;
}

/*==================================================================*/
/*======================= Toogle Select ============================*/
/*==================================================================*/

.c-toogles{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;
}

/*==================================================================*/
/*=================== Vinculo Nota Fiscal Recebida =================*/
/*==================================================================*/

.c-vinculo-nota-fiscal-recebida{
    display: grid; 
    grid-template-columns: max-content max-content; 
    grid-template-rows: max-content max-content; 
    gap: 10px 0px; 
    grid-template-areas: 
        "VinculoBotao VinculoSeletor"
        ". VinculoDetalhes"; 
}

.c-vinculo__seletor {
    grid-area: VinculoSeletor;
}

.c-vinculo__detalhes {
    display: flex;
    justify-self: center;
    grid-area: VinculoDetalhes;
}

/*==================================================================*/
/*====================== Vinculo Adiantamento ======================*/
/*==================================================================*/

.c-vinculo-adiantamento{
    display: grid; 
    grid-template-columns: max-content; 
    grid-template-rows: max-content; 
    gap: 10px 0px; 
    grid-template-areas: 
        "VinculoSeletor"
        "VinculoDetalhes"; 
}

/*==================================================================*/
/*======================= Vinculo Elementos ========================*/
/*==================================================================*/

.c-vinculo__botao { 
    grid-area: VinculoBotao;
}

.c-vinculo__seletor {
    grid-area: VinculoSeletor;
}

.c-vinculo__detalhes {
    display: flex;
    justify-self: center;
    grid-area: VinculoDetalhes;
}

/*==================================================================*/
/*=========================== Checkbox =============================*/
/*==================================================================*/

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox.v-input--is-label-active >>> .v-input--selection-controls__ripple{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.c-checkbox.v-input--is-label-active >>> .v-icon{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

/*==================================================================*/
/*========================== Money Input ===========================*/
/*==================================================================*/

.c-money.v-input--is-disabled >>> input{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-money.v-input--is-disabled >>> label{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-money >>> .v-icon{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-money:not(.v-input--is-disabled) >>> .v-input__slot{
    background-color: white;
}

.c-money:not(.v-input--is-disabled) >>> .v-input__slot{
    background-color: white;
}

/*==================================================================*/
/*============================= Botões =============================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-expandir-pagamentos{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

</style>